import { ContactType } from 'views/ContactNoteForm/components/data/contactTypeOptions';

export const CommunicationChannelEndDateList = [
  ContactType.MEETING,
  ContactType.EVENT,
  ContactType.PHONE_CALL,
  ContactType.CHAT,
  ContactType.OTHER,
];

export const CommunicationChannelCountryShowList = [ContactType.MEETING, ContactType.EVENT, ContactType.OTHER];

export const CommunicationChannelDirectionShowList = [
  ContactType.EMAIL,
  ContactType.FAX,
  ContactType.PHONE_CALL,
  ContactType.LETTER,
];
